export interface Competence {
  id?: number;
  name: string;
  sourceCompetenceId?: number;
}

export const createCompetenceInitial = (): Competence => {
  return {
    id: undefined,
    name: "",
    sourceCompetenceId: undefined
  };
}